import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setupInterceptors } from '../../utils/api';

const AxiosInterceptorProvider = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setupInterceptors(dispatch, navigate);
  }, [dispatch, navigate]);

  return null;
};

export default AxiosInterceptorProvider;
